import { render, staticRenderFns } from "./NoRecord.vue?vue&type=template&id=fac4f79e&"
import script from "./NoRecord.vue?vue&type=script&lang=js&"
export * from "./NoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports